<template lang="pug">
    .form__tabs
        .form-tabs__blocks
            .form-tabs__block(
                v-for='number in tabsNumber'
                :key="number"
                @click='setCurrentTab(number)'
                :class="{'form__tab--active': number === currentTab, 'form-tabs__block_is-disabled': sameSettingsAreActive && currentTab !== number}"
                @dblclick="handleTabDoubleClick(number)"
            )
                span(v-if="!canEditTabName(number)")
                    |  {{ namesArray[number - 1] }}
                input.edit-name-input(
                    v-else-if="canEditTabName(number)"
                    :value="namesArray[number - 1]"
                    ref="input"
                    v-focus="true"
                    maxlength=9
                    @blur="checkInputValue($event.target.value, number - 1)"
                    @keydown.enter="checkInputValue($event.target.value, number - 1)"
                )
</template>

<script>
    const TYPE_PLAYER = 'player';
    const TYPE_HOMEWORK = 'homework';

    export default {
        props: {
            tabsNumber: {
                type: [Number],
                default: 2,
            },
            homeworkTabAfterGameEdit: {
                type: [Number],
                default: 1,
            },
            sameSettingsAreActive: {
                type: [Boolean],
                default: false,
            },
            elementsType: {
                type: [String],
                default: TYPE_PLAYER,
            },
            disableNameChange: {
                type: [Boolean],
                default: false,
            },
            customTabNames: {
                type: [Array],
                default: () => [],
            },
        },
        data() {
            return {
                currentTab: 1,
                currentEditTab: 0,
                namesArray: [],
            };
        },
        watch: {
            homeworkTabAfterGameEdit: {
                handler(val) {
                    this.setCurrentTab(val);
                },
            },
            namesArray: {
                handler(val) {
                    this.$emit('setNamesArray', val);
                },
                immediate: true,
            },
            tabsNumber: {
                handler(val) {
                    for (let i = 0; i < val; i++) {
                        if (!this.namesArray[i]) {
                            if (this.elementsType === TYPE_PLAYER) {
                                this.namesArray.push(this.$i18n.t('common.common_userType_player') + ' ' + (i + 1));
                            } else if (this.elementsType === TYPE_HOMEWORK) {
                                this.namesArray.push(this.customTabNames[i]);
                            }
                            if (this.tabsNumber !== this.customTabNames.length) {
                                this.$emit('wrongTabsAmount', this.tabsNumber);
                            }
                        }
                        this.namesArray = this.namesArray.slice(0, val);
                    }
                },
                immediate: true,
            },
        },
        methods: {
            handleTabDoubleClick(number) {
                if (!this.disableNameChange) {
                    this.currentEditTab = number;
                }
            },
            setCurrentTab(number) {
                this.currentTab = number;
                this.$emit('setCurrentTab', number);
            },
            canEditTabName(number) {
                return number === this.currentEditTab;
            },
            checkInputValue(val, index) {
                if (!val.replace(/\s+/g, ' ').trim() || val === ' ') {
                    this.$toasted.error(this.$i18n.t('trainer.trainer_gameFormSetting_FieldMustNotBeEmpty'));
                    this.$refs.input[0].focus();
                    return;
                }
                this.$set(this.namesArray, index, val.trim());
                this.currentEditTab = 0;
            },
        },
    };
</script>

<style lang="scss" scoped>
    .form__tabs {
        display: flex;
        flex-direction: column;
        @include stack-space($space-x-large);
    }

    .form-tabs__blocks {
        display: flex;
        margin-bottom: 6px;
        padding: 0 25px;
        font-size: 13px;
        @include media($xl) {
            font-size: 16px;
        }
    }

    .form-tabs__block {
        flex: 1 1 auto;
        text-align: center;
        border: 1px solid $hsl-color-gray-94;
        border-radius: $border-radius-10 $border-radius-10 0 0;
        padding: 5px;
        white-space: nowrap;
        cursor: pointer;
        @include media($sm) {
            @include inline-space($space-small);
            margin-bottom: -$space-x-small;
        }
        @include media($xl) {
            padding: 5px 10px;
        }
    }

    .form-tabs__block_is-disabled {
        pointer-events: none;
        opacity: 0.4;
    }

    .form__tab--active {
        background-color: $hsl-color-gray-94;
    }

    .edit-name-input {
        width: 100%;
        height: 100%;
        border: 1px solid $hsl-color-gray-20;
        border-radius: 3px;
        outline: none;
        font-size: 12px;
        @include media($xl) {
            font-size: 16px;
        }
        &:focus {
            box-shadow: 0 0 2px $hsl-color-gray-20;
        }
    }
</style>
